export default __webpack_public_path__ + "static/media/tbl-prize1.14486f8d.svg";